/** DTO alignés sur les tables backend (snake_case). */

/** Réponse typique GET `/api/parametrage/data-modules` — `table_db_id` peut être absent (fallback : `id`). */
export interface RefDataModuleDto {
  id: number;
  code: string;
  libelle: string;
  /** Nom de table métier (chaîne), ex. `"products"` */
  table_db?: string;
  /** Identifiant numérique table si exposé ; sinon voir `resolveRefModuleTableDbId`. */
  table_db_id?: number;
  ordre: number;
  created_at?: string;
  updated_at?: string;
}

/** Identifiant utilisé dans les routes `…/by-table/:table_db_id` — aligné sur votre API (`table_db_id` ou `id`). */
export function resolveRefModuleTableDbId(ref: RefDataModuleDto): number {
  const explicit = Number(ref.table_db_id);
  if (Number.isFinite(explicit) && explicit > 0) {
    return explicit;
  }
  const fallback = Number(ref.id);
  return Number.isFinite(fallback) && fallback > 0 ? fallback : NaN;
}

export interface DataModuleSettingsDto {
  id?: number;
  station_id: number;
  module_id: number;
  champs_perso_actifs: boolean;
  groupes_actifs: boolean;
  tags_actifs: boolean;
  variantes_actives: boolean;
  max_champs_perso: number;
  historisation: boolean;
  filtres_avances: boolean;
}

export interface DataModuleUsageDto {
  id?: number;
  station_id: number;
  module_id: number;
  promo_declenchement: boolean;
  promo_exclusion: boolean;
  promo_regroupement: boolean;
  tarif_regles: boolean;
  tarif_generation_prix: boolean;
  reporting_bi: boolean;
  reporting_exports: boolean;
  workflow_validations: boolean;
  workflow_automatisations: boolean;
  recherche_simple: boolean;
  recherche_avancee: boolean;
}

export interface ParamTableFieldDto {
  id: number;
  station_id: number;
  user_id: number | null;
  table_db_id: number;
  champ_db: string;
  libelle_champ: string;
  type: string;
  ordre: number;
  groupe: string | null;
  description: string | null;
  placeholder: string | null;
  valeur_defaut: string | null;
  obligatoire: boolean;
  actif: boolean;
  unique_value: boolean;
  lecture_seule: boolean;
  utilise_dans: string | null;
  options_json: unknown;
  display_json: unknown;
  api_json: unknown;
  usage_json: unknown;
}

/**
 * Corps POST `/api/parametrage/select-params` (une option = une requête).
 * `station_id` / `user_id` en query.
 */
export interface SelectParamsPostSingleDto {
  param_table_id: number;
  libelle: string;
  code?: string;
  couleur?: string;
}

/** Corps PUT `/api/parametrage/select-params/:id` */
export interface SelectParamsPutDto {
  libelle?: string;
  code?: string;
  couleur?: string;
}

/** Ligne renvoyée par GET `/api/parametrage/select-params/param-table/:param_table_id` */
export interface SelectParamOptionDto {
  id: number;
  libelle: string;
  value: string;
  couleur?: string;
}

export interface ParamRuleDto {
  id: number;
  station_id: number;
  table_db_id: number;
  champ_source: string;
  operateur: string;
  valeur_comparaison: string;
  action: string;
  champ_cible: string;
  priorite: number;
  statut: string;
  active: boolean;
}

export interface ParamAuditLogDto {
  id: number;
  station_id: number;
  table_db_id: number | null;
  /** Horodatage serveur (prioritaire pour l’affichage « Date »). */
  logged_at?: string | null;
  /** Ancien / second champ date si `logged_at` absent. */
  date?: string;
  user_id: number;
  /** Backend peut exposer `action` ou faute de frappe `ction` */
  action?: string;
  ction?: string;
  objet: string;
  ancienne_valeur: string | null;
  nouvelle_valeur: string | null;
  source: string | null;
}

export interface DataImportFormatDto {
  id: number;
  station_id: number;
  table_db_id: number;
  nom: string;
  extension: string;
  description: string | null;
  config_json: unknown;
  actif: boolean;
}

export interface DataImportMappingDto {
  id?: number;
  import_format_id: number;
  colonne_fichier: string;
  champ_cible: string;
  transformation: string;
}

export interface DataExportFormatDto {
  id: number;
  station_id: number;
  table_db_id: number;
  nom: string;
  type: string;
  config_json: unknown;
  actif: boolean;
}

export interface DataExportDestinationDto {
  id?: number;
  station_id: number;
  table_db_id: number;
  export_format_id: number | null;
  type_destination: string;
  config_json: unknown;
}

/** Ligne data_export_mapping (GET /export-formats/:id/mapping) */
export interface DataExportMappingDto {
  id: number;
  export_format_id: number;
  champ_source: string;
  colonne_fichier: string;
  transformation: string | null;
  ordre: number;
}

/** Corps attendu pour PUT /export-formats/:id/mapping (sans id — remplacement liste) */
export interface DataExportMappingWriteDto {
  champ_source: string;
  colonne_fichier: string;
  transformation: string | null;
  ordre: number;
}
